import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ProLabel from 'components/common/ProLabel/index.js';

import './DashboardFormSection.css';


const DashboardFormSection = props => {
  const {
    header,
    headerItem,
    children,
    proLabel,
    noBordered,
    noPadding,
    className: customClassName,
    expanded,
    defaultExpandMode,
    infoUrl,
  } = props;

  const [showContent, setShowContent] = useState(true);

  useEffect(() => {
    if (expanded && !defaultExpandMode) {
      setShowContent(defaultExpandMode);
    }
  }, []);

  useEffect(() => {
    if (expanded) {
      setShowContent(defaultExpandMode);
    }
  }, [expanded]);

  const calculateClassName = () => {
    let className = 'dashboard-form-section__component';
    if (noBordered) { className += ' no-bordered'; }
    if (noPadding) { className += ' no-padding'; }
    if (customClassName) { className += ` ${customClassName}`; }
    if (!showContent) { className += ' closed'; }
    return className;
  };

  const handleExpand = () => {
    if (expanded) {
      setShowContent(!showContent);
    }
  };

  return (
    <div className={calculateClassName()}>
      {(header || headerItem) &&
        <div
          className="section-header"
          onClick={handleExpand}
          role="button"
          tabIndex={-1}
        >
          <div className="title-block">
            <div className="title">
              {header}
              {infoUrl &&
                <a
                  className="info-icon"
                  href={infoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              }
              {proLabel && <ProLabel />}
            </div>
            {expanded &&
              <div className={`arrow ${showContent ? ' opened' : ''}`} />
            }
          </div>
          <div className="header-item">{headerItem && headerItem}</div>
        </div>
      }

      {showContent &&
        <div className="section-content">
          {children}
        </div>
      }
    </div>
  );
};

DashboardFormSection.propTypes = {
  header: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  headerItem: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  proLabel: PropTypes.bool,
  noBordered: PropTypes.bool,
  noPadding: PropTypes.bool,
  className: PropTypes.string,
  expanded: PropTypes.bool,
  defaultExpandMode: PropTypes.bool,
  infoUrl: PropTypes.string,
};

DashboardFormSection.defaultProps = {
  header: null,
  headerItem: null,
  proLabel: false,
  noBordered: null,
  noPadding: null,
  className: null,
  expanded: null,
  defaultExpandMode: null,
  infoUrl: null,
};

export default DashboardFormSection;
